/* ============
 * Create reminder
 * ============
 */

import Vue from 'vue';

export default (id, params = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.post(`bills/create-reminder/${id}`, params)
    .then((response) => {
      resolve(response.data);
    })
    .catch((error) => {
      reject(error.response.data);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/bill/createReminder.js